import { z } from 'zod'
import { communityTag } from './community-tags'

const kind=z.enum(['question','idea','experiment','replication','comment'])
const view=z.enum(['work','projects','discussions','join','search'])
export function communitySearch(raw:Record<string,unknown>){
 const tag=communityTag.safeParse(raw.tag);const type=kind.safeParse(raw.kind);const challenge=z.string().uuid().safeParse(raw.challengeId)
 const section=view.safeParse(raw.view)
 return {q:typeof raw.q==='string'?raw.q.trim().slice(0,120)||undefined:undefined,tag:tag.success?tag.data:undefined,kind:type.success?type.data:undefined,challengeId:challenge.success?challenge.data:undefined,...(section.success?{view:section.data}:{})}
}
export type CommunitySearch=ReturnType<typeof communitySearch>
